import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { initialMessage, userMessage } from 'constants/ui.constants';
import _ from 'lodash';

interface ICompanyState {
	altshulerLeads: Record<string, string>[] | null;
	altshulerManagers: Record<string, string>[] | null;
	altshulerAgents: Record<string, string>[] | null;
	altshulerDealers: Record<string, string>[] | null;
	boUsers: Record<string, string>[] | null;
	error: userMessage;
	isLoading: boolean;
}

const initialState: ICompanyState = {
	altshulerLeads: null,
	altshulerManagers: null,
	altshulerAgents: null,
	altshulerDealers: null,
	boUsers: null,
	error: initialMessage,
	isLoading: false,
};

export const companySlice = createSlice({
	name: 'company',
	initialState,
	reducers: {
		setAltshulerEmployees: (state, { payload }) => {
			const { agents, leads, dealers, managers, boUsers } = payload;
			state.altshulerLeads = leads.map((lead: any) => {
				return { ...lead, value: lead.id, label: lead.name };
			});
			state.altshulerAgents = agents.map((lead: any) => {
				return { ...lead, value: lead.id, label: lead.name };
			});
			state.altshulerDealers = dealers.map((lead: any) => {
				return { ...lead, value: lead.id, label: lead.name };
			});
			state.altshulerManagers = managers.map((lead: any) => {
				return { ...lead, value: lead.id, label: lead.name };
			});
			state.boUsers = boUsers.map((boUser: any) => {
				return { ...boUser, value: boUser.id, label: boUser.name };
			});
		},
		setAltshulerManagers: (state, { payload }) => {
			if (_.isArray(state.altshulerManagers)) {
				let group = _.keyBy([...state.altshulerManagers], 'id');
				group = { ...group, [payload.id]: { ...payload, value: payload?.id, label: payload?.name } };
				state.altshulerManagers = _.values(group);
			}
		},
		setAltshulerAgents: (state, { payload }) => {
			if (_.isArray(state.altshulerAgents)) {
				let group = _.keyBy([...state.altshulerAgents], 'id');
				group = { ...group, [payload.id]: { ...payload, value: payload?.id, label: payload?.name } };
				state.altshulerAgents = _.values(group);
			}
		},
		setAltshulerLeads: (state, { payload }) => {
			if (_.isArray(state.altshulerLeads)) {
				let group = _.keyBy([...state.altshulerLeads], 'id');
				group = { ...group, [payload.id]: { ...payload, value: payload?.id, label: payload?.name } };
				state.altshulerLeads = _.values(group);
			}
		},
		setAltshulerDealers: (state, { payload }) => {
			if (_.isArray(state.altshulerDealers)) {
				let group = _.keyBy([...state.altshulerDealers], 'id');
				group = { ...group, [payload.id]: { ...payload, value: payload?.id, label: payload?.name } };
				state.altshulerDealers = _.values(group);
			}
		},
		setError: (state, action: PayloadAction<userMessage>) => {
			state.error = action.payload;
		},
		setLoading: (state, { payload }) => {
			state.isLoading = payload;
		},
	},
});
const selectA = (state) => state.company;

const filterActive = (arr: any, active?: boolean) => {
	return active ? _.filter(arr, { active: true }) : arr;
};

export const getAltshulerEmployees = (active?: boolean) =>
	createSelector([selectA], (state: any) => {
		return {
			altshulerLeads: filterActive(state.altshulerLeads, active),
			altshulerAgents: filterActive(state.altshulerAgents, active),
			altshulerDealers: filterActive(state.altshulerDealers, active),
			altshulerManagers: filterActive(state.altshulerManagers, active),
			boUsers: filterActive(state.boUsers, active),
		};
	});

export const getError = (state: any) => {
	return state.company.error;
};

export const getLoading = (state: any) => {
	return state.balance.isLoading;
};
export const {
	setAltshulerEmployees,
	setError,
	setLoading,
	setAltshulerManagers,
	setAltshulerAgents,
	setAltshulerDealers,
	setAltshulerLeads,
} = companySlice.actions;

export default companySlice.reducer;
